// extracted by mini-css-extract-plugin
module.exports = {"input-wrapper":"InputQuantity_input-wrapper__8Axcb","full-width":"InputQuantity_full-width__mm7ig","input":"InputQuantity_input__7ssto","btn":"InputQuantity_btn__Vl3BM"};